export default __webpack_public_path__ + "static/3-f02e693e91f6435eb6d1278a35a99d47.webp";